import styled from 'styled-components';
import { Media } from 'enums';
import { Button } from 'view/atoms';

export const ButtonChangeLocation = styled(Button)`
  display: flex;
  height: 48px;
  margin-top: 40px;
  column-gap: 10px;

  @media ${Media.notebook} {
    height: 64px;
    width: 343px;
    margin-top: 54px;
  }
`;
